<template>
    <div>

        <div v-if="(data.reviewStatus!=0 ? false : ((data.stepStatus==4||data.stepStatus==5 ||data.stepStatus==6)&& !data.isAnswerEnd && tab.isDownload==1))">
            <div v-if="data.infoData.abolish==1">
                <el-alert title="" type="error" :closable="false">请务必上传现场踏勘表</el-alert>
            </div>
            <el-button type="primary" :disabled="!data.reconButtonFlag" size="mini" @click="data.reconQstDialogShow = true"><b>+</b> 我的提疑</el-button>
            <el-button type="primary" :disabled="!data.reconButtonFlag" size="mini" @click="data.reconTableDialogShow = true"><b>+</b> 现场踏勘表</el-button>
            <span  class="title" >提疑截止时间：{{ data.infoData.fquestionenddate }}</span>
        </div>


        <div v-if="(data.reviewStatus!=0 ? data.reviewStatus==5 : (data.stepStatus==5 || (data.stepStatus==6 && !data.isAnswerEnd)))">

            <el-tabs v-model="data.reconQstTabelTabActive" type="card" class="tabs-margin U">

                <el-tab-pane :name="'tab01'">
                    <span slot="label">我的提疑</span>
                    <div v-if="data.reconQstListShowed.length == 0" class="no-data-tip"></div>
                    <ul v-else class="invite-mng-list">
                        <li v-for="li in data.reconQstList" v-if="li.questionType!=2" :key="li.id"><a @click="showReconQstList(li.id)" href="javascript:;">【{{ ['标书','踏勘'][li.questionType] }}提疑】 {{ li.askTitle }} </a><span style="float: right;">{{ li.askDate }}</span></li>
                    </ul>
                </el-tab-pane>

                <el-tab-pane :name="'tab02'">
                    <span slot="label">现场踏勘表</span>
                    <div v-if="data.reconTableList.length == 0" class="no-data-tip"></div>
                    <ul v-else class="invite-mng-list">
                        <li v-for="li in data.reconTableList" :key="li.id"><a :href="data.downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a> <span style="float:right;">{{ li.createDate||'0000-00-00' }}</span></li>
                    </ul>
                </el-tab-pane>

            </el-tabs>


            <el-tabs v-model="data.reconReplyTabActive" type="card" class="tabs-margin U">

                <el-tab-pane :name="'fixed'">
                    <span slot="label">招标人答疑回复列表</span>

                    <div v-if="data.reconReplyList.length == 0" class="no-data-tip"></div>
                    <ul v-else class="invite-mng-list">
                        <li v-for="(li,index) in data.reconReplyList" :key="li.id"><a href="javascript:;" @click="showReconReply(index)">{{ li.answerContent&&li.answerContent.length>30 ? (li.answerContent.substring(0,30)+'..') : (li.answerContent||'#答疑#') }}</a> <span style="float:right;">{{ li.createDate }}</span></li>
                    </ul>
                </el-tab-pane>

            </el-tabs>

        </div>


    </div>
</template>

<script>
    export default {
        name: "invite-recon",
        data () {
            return {
            }
        },
        props: [
            'data',
            'tab',
            'showReconReply',
            'showReconQstList'
        ],
        created () {

        },
    }
</script>

<style scoped>
.tabs-margin {margin:20px 0 40px 0;}

a {color:var(--cMain);}

ul {padding: 0;margin:0;}
ul li {list-style:none;}

ul.invite-mng-list li {padding:14px 12px;font-size:14px;}
ul.invite-mng-list li + li {border-top:1px dashed #E5E6E5;}
ul.invite-mng-list li a {color:var(--cTxt1);text-decoration:none;}
ul.invite-mng-list li a:hover {color:var(--cMain);}

.el-alert.el-alert--error {margin:12px 0;}
.title{
    float:right;
    font-size:14px;
    color:#333;
}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteRecon.vue